export default function createBulletSTL(profile, numSegments = 100) {
  const facets = [];

  for (let i = 0; i < profile.length - 1; i++) {
    const p1 = profile[i];
    const p2 = profile[i + 1];

    for (let j = 0; j < numSegments; j++) {
      const angle1 = (j / numSegments) * Math.PI * 2;
      const angle2 = ((j + 1) / numSegments) * Math.PI * 2;

      // Calculate points
      const points = [
        polarToCartesian((p1.diameter* 25.4) / 2, angle1, p1.dist * 25.4),
        polarToCartesian((p2.diameter* 25.4) / 2, angle1, p2.dist * 25.4),
        polarToCartesian((p2.diameter* 25.4) / 2, angle2, p2.dist * 25.4),
        polarToCartesian((p1.diameter* 25.4) / 2, angle2, p1.dist * 25.4)
      ];

      // Create two triangles for each quad
      facets.push(createFacet(points[0], points[1], points[2], true));
      facets.push(createFacet(points[2], points[3], points[0], true));
    }
  }

  return writeSTL(facets);
}

function createFacet(p1, p2, p3) {
  // Calculate normal
  let normal = calculateNormal(p1, p2, p3);

  // Use the midpoint of the facet for the direction check
  const midpoint = {
    x: (p1.x + p2.x + p3.x) / 3,
    y: (p1.y + p2.y + p3.y) / 3,
    z: (p1.z + p2.z + p3.z) / 3
  };

  // Vector from center to midpoint
  const centerToMidpoint = { x: midpoint.x, y: midpoint.y, z: midpoint.z };

  // Check if normal is pointing inward by dot product
  if (dotProduct(normal, centerToMidpoint) < 0) {
    // Normal is pointing inward, reverse it
    [p2, p3] = [p3, p2];
    normal = calculateNormal(p1, p2, p3);
  }

  return { normal, vertices: [p1, p2, p3] };
}

function dotProduct(v1, v2) {
  return v1.x * v2.x + v1.y * v2.y + v1.z * v2.z;
}


function calculateNormal(p1, p2, p3) {
  // Calculate vectors
  const v1 = { x: p2.x - p1.x, y: p2.y - p1.y, z: p2.z - p1.z };
  const v2 = { x: p3.x - p1.x, y: p3.y - p1.y, z: p3.z - p1.z };

  // Calculate and normalize normal
  let normal = {
    x: v1.y * v2.z - v1.z * v2.y,
    y: v1.z * v2.x - v1.x * v2.z,
    z: v1.x * v2.y - v1.y * v2.x
  };
  const length = Math.sqrt(normal.x * normal.x + normal.y * normal.y + normal.z * normal.z);
  if (length > 0) {
    normal.x /= length;
    normal.y /= length;
    normal.z /= length;
  }

  return normal;
}

function polarToCartesian(radius, angle, x) {
  return {
    x,
    z: radius * Math.cos(angle),
    y: radius * Math.sin(angle),
  };
}

function writeSTL(facets) {
  let stl = "solid bullet\n";
  for (const facet of facets) {
    stl += `facet normal ${format(facet.normal.x)} ${format(facet.normal.y)} ${format(facet.normal.z)}\n`;
    stl += "    outer loop\n";
    for (const vertex of facet.vertices) {
      stl += `        vertex ${format(vertex.x)} ${format(vertex.y)} ${format(vertex.z)}\n`;
    }
    stl += "    endloop\n";
    stl += "endfacet\n";
  }
  stl += "endsolid bullet";
  return stl;
}

function format(num, precision = 6, threshold = 1e-10) {
  // If the number is too close to zero, set it to zero
  if (Math.abs(num) < threshold) {
    return '0.000000e+0';
  }
  // Otherwise, format it in exponential notation
  return num.toExponential(precision);
}
